var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.item.user_roles),function(role){return [_c('b-badge',{key:'role_' + role.id},[_vm._v(_vm._s(role.label))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }